<template>
  <b-container fluid class="gradient">
    <b-row align-h="center" class="full-height">
      <b-col md="6" lg="4" align-self="center">
        <b-card>
          <div class="text-center">
            <img class="logo" src="/img/new-logo.svg" />
          </div>
          <b-form class="form" autcomplete="on">
            <b-alert variant="danger" class="text-center" :show="authError">Oh, you made a mistake !</b-alert>

            <b-form-group>
              <b-input-group>
                <b-input-group-text slot="prepend">
                  <font-awesome-icon icon="at" />
                </b-input-group-text>
                <b-form-input
                  v-model.trim="form.email"
                  placeholder="Email address"
                  required="required"
                  type="email"
                  name="email"
                  size="lg"
                  v-focus
                  @keyup.native.enter="login"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group>
              <b-input-group>
                <b-input-group-text slot="prepend">
                  <font-awesome-icon icon="lock" />
                </b-input-group-text>
                <b-form-input
                  v-model.trim="form.password"
                  placeholder="Password"
                  required="required"
                  type="password"
                  name="password"
                  size="lg"
                  @keyup.native.enter="login"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group>
              <b-button size="lg" block variant="primary" @click="login">
                <strong>Login</strong>
              </b-button>
            </b-form-group>
          </b-form>

          <b-row slot="footer">
            <b-col>
              <router-link :to="{ name: 'lost' }">I Forgot my password</router-link>
            </b-col>
            <b-col class="text-sm-right">
              <router-link :to="{ name: 'signup' }" class="pull-right">New here?</router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script type="text/javascript">
const DEFAULT = {
  email: '',
  password: ''
}
export default {
  data: () => ({
    form: { ...DEFAULT },
    authError: false
  }),
  methods: {
    clearForm() {
      this.form = { ...DEFAULT }
    },
    login() {
      this.$emit('login', this.form)
      this.$store
        .dispatch('login', this.form)
        .then(() => {
          this.$router.push({ name: 'dashboard' })
        })
        .catch(() => {
          this.authError = true
        })
    }
  }
}
</script>
